import scoringRules from '@scoutgg/scoring-rules';
const rules = scoringRules('american_football')
import gaussian from 'gaussian';

const OFF_SCORING_RULES = {
  PassingTouchdowns: 'passingTd',
  PassingYards: 'passingYards',
  PassingInterceptions: 'intercepted',
  RushingTouchdowns: 'rushingTd',
  RushingYards: 'rushingYards',
  ReceivingTouchdowns: 'receivingTd',
  ReceivingYards: 'receivingYards',
  Receptions: 'reception',
  ReturnTouchdowns: 'returnTd',
  FumblesLost: 'fumbleLost',
  Conversion: 'conversion',
}
const ST_SCORING_RULES = {
  Sacks: 'sack',
  Interceptions: 'interception',
  FumblesRecovered: 'fumbleRecovery',
  DefensiveTouchdowns: 'defensiveTd',
  Safeties: 'safety',
  BlockedKicks: 'blockedKick',
}

const OFF_MODEL = {
  min: 4,
}
const POINTS_VARIANCE = 223.9079480380091
const POINTS_ALLOWED_VALUES = [0, 1, 7, 14, 21, 28, 35]

function makePrice({ player, price, match, side, factors }) {
  let playerLineup = match.lineups.find(p => p.player._id === player._id)
  if(playerLineup && playerLineup.xFP) {
    playerLineup.xFP = Math.max(OFF_MODEL.min, playerLineup.xFP)
    return playerLineup.xFP.toFixed(1)
  }

  return 0
}

function getXfpFromProjection(projection) {
  let result = 0
  projection['Conversion'] = projection['TwoPointConversionRuns'] +
    projection['TwoPointConversionPasses'] +
    projection['TwoPointConversionReceptions']
  projection['ReturnTouchdowns'] = projection['BlockedKickReturnTouchdowns'] +
    projection['FieldGoalReturnTouchdowns'] +
    projection['InterceptionReturnTouchdowns'] +
    projection['KickReturnTouchdowns'] + projection['PuntReturnTouchdowns']

  for(let index in OFF_SCORING_RULES) {
    result += projection[index] * rules.points(OFF_SCORING_RULES[index])
  }

  return result !== 0 && result
}

function getXfpFromDstProjection(projection) {
  let result = 0

  for(let index in ST_SCORING_RULES) {
    result += projection[index] *
      rules.points(ST_SCORING_RULES[index], 'defense_special')
  }

  const allowedProbabilities = getAllowedPointsProbabilities(projection)
  for(let value in allowedProbabilities) {
    result += allowedProbabilities[value] *
      rules.points(`allowed${value}`, 'defense_special')
  }

  return result !== 0 && result
}

function getAllowedPointsProbabilities(projection) {
  const distribution = gaussian(projection['PointsAllowed'], POINTS_VARIANCE)
  const result = {}
  for(let i in POINTS_ALLOWED_VALUES) {
    let probability
    let value = POINTS_ALLOWED_VALUES[i]
    if(i === '0') {
      probability = distribution.cdf(value)
    } else {
      probability = (
        POINTS_ALLOWED_VALUES.length > ~~i + 1
          ? distribution.cdf(POINTS_ALLOWED_VALUES[~~i + 1])
          : 1
      ) - distribution.cdf(value)
    }
    result[value] = probability
  }

  return result
}

export default {
  getXfpFromProjection,
  getXfpFromDstProjection,
  getAllowedPointsProbabilities,
  makePrice,
};
